// extracted by mini-css-extract-plugin
module.exports = {"Box":"CustomFadeBox_Box__31aNY","Div":"CustomFadeBox_Div__3QY52","LargeDiv":"CustomFadeBox_LargeDiv__1sbYR"};